import { render } from "./FormLabel.vue?vue&type=template&id=377f0814&scoped=true&ts=true"
import script from "./FormLabel.vue?vue&type=script&lang=ts"
export * from "./FormLabel.vue?vue&type=script&lang=ts"

import "./FormLabel.vue?vue&type=style&index=0&id=377f0814&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377f0814"]])

export default __exports__